/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  recordAdOutcome(conversationID, payload) {
    return axios.post(`${this.url}/${conversationID}/ad_outcomes`, payload);
  }
}

export default new ConversationApi();
